<template>
    <div class="footer">
        <div>
            <div>
                <a href="https://nmlz.saicjg.com/siteweb/#/allSitePage?companyName=赤峰瑞阳化工有限公司&siteDomain=http://manage.91huadd.com/ry-website&companyNumber=9115040377612641X1" height="24" width="24">
                            <img src="https://nmlz.saicjg.com/siteweb/title_logo.png" lazysrc="https://nmlz.saicjg.com/siteweb/title_logo.png"/>
                      </a>

                <img src="../assets/logo.jpg">
            </div>
            <div>
                <div>了解我们</div>
                <div @click="goRouter('/')">首页</div>
                <div @click="goRouter('/shop_auction')">商品</div>
                <div>服务</div>
                <div @click="goRouter('/me')">个人中心</div>
            </div>
            <div>
                <div>联系方式</div>
                <div>官网联系电话 0476-5999167</div>
                <div>内蒙古自治区赤峰市资源型城市经济转型开发试验区</div>
                <div>ruiyanghuagong@sina.com</div>
            </div>
            <div>
                <div style="opacity: 0;">联系方式</div>
                <div>部门经理 陈胥 13914313977（全系列产品）</div>
                <div>业务经理 孙杰 15995054200（硫酸钠、双三羟、甲酸、甲乙醛、轻组分、重组分）</div>
                <div>业务经理 刘旭明 13961205018（甲酸钠、特级/99级季戊四醇）</div>
                <div>业务经理 肖坚强 13734781184（酒精、饲料、二氧化碳、混合戊醇）</div>
            </div>
            <!-- <div>
                <img src="../assets/logo.jpg">
            </div> -->
        </div>
    </div>
</template>

<script>
    export default {
        name: "Footer",
        data() {
            return {}
        }
    };
</script>

<style scoped>
    .footer {
        height: 275px;
        background: #34343B;
        color: #FFFFFF;
    }

    .footer>div {
        width: 1200px;
        height: 275px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .footer>div>div:nth-child(1){
        display: block;
    }

    .footer>div>div:nth-child(1)>a>img:nth-child(1) {
        width: 40px;
        height: 40px;
    }

    .footer>div>div:nth-child(1)>img:nth-child(2) {
        width: 178px;
        height: 50px;
    }

    .footer>div>div:nth-child(2)>div,
    .footer>div>div:nth-child(3)>div,
    .footer>div>div:nth-child(4)>div {
        color: #FFFFFF;
        font-size: 14px;
        text-align: left;
        cursor: pointer;
    }

    .footer>div>div:nth-child(2)>div:nth-child(1),
    .footer>div>div:nth-child(3)>div:nth-child(1),
    .footer>div>div:nth-child(4)>div:nth-child(1) {
        font-size: 20px;
        margin-bottom: 24px;
    }

    .footer>div>div:nth-child(2)>div,
    .footer>div>div:nth-child(4)>div {
        margin-bottom: 14px;
    }

    .footer>div>div:nth-child(3)>div {
        margin-bottom: 28px;
    }

    .footer>div>div:nth-child(2)>div:last-child,
    .footer>div>div:nth-child(3)>div:last-child,
    .footer>div>div:nth-child(4)>div:last-child {
        margin-bottom: 0;
    }

    /* .footer>div>div:nth-child(4)>img {
        width: 122px;
        height: 122px;
    } */
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue